<template>
    <div class="p-5 text-center">
        <check-circle-icon size="4x" class="text-success mb-3"></check-circle-icon>
        <h2>Grazie per il tuo ordine</h2>
        <p>Per effettuare il pagamento tramite bonifico usa i riferimenti seguenti</p>
        <div class="border">
            <p>Benediciario: <strong>GeneralGas srl</strong></p>
            <p>IBAN: <strong>IT 55 T 02008 05364 0001 0373 0802</strong></p>
            <p>Causale: <strong>Acquisto Crediti Smart378</strong></p>
            <p>Codice BIC/SWIFT: <strong>UNCRITMMOMI</strong></p>
        </div>
        <a href="/" class="btn btn-primary">Vai alla home</a>
    </div>
</template>

<script>
import { Requests } from '@/api/requests';
import { CheckCircleIcon } from 'vue-feather-icons';
export default {
    components: {
        CheckCircleIcon
    },
}
</script>